import { render, staticRenderFns } from "./automatic.vue?vue&type=template&id=04ca4f2d&"
import script from "./automatic.vue?vue&type=script&lang=ts&"
export * from "./automatic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports